import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
@Component({
  selector: 'xchange-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
  title: string = "Confirm";
  content: string = "Would you like to continue?";
  primaryActionLabel: string = "Ok Shopping";
  secondaryActionLabel: string = "Cancel";
  onSecondaryAction: Function = () => {};
  onPrimaryAction: Function = () => {};
  spinnerLoading = false;
  errorMessage = "";
  
  constructor(
    private modalService: BsModalService,
  ) { }

  handleAction(type: string) {
    type === 'primary' ? this.onPrimaryAction() : this.onSecondaryAction();
    this.modalService.hide("confirmation");
  }

  ngOnInit(): void {
  }

}
